import { IconButton, Tooltip, Box, IconButtonProps } from '@applift/factor'
import { Delete } from '@applift/icons'
import { useCallback } from 'react'

interface Props {
  id: number
  onDelete: (id: number) => void
  disabled?: boolean
  tooltip?: string
  buttonProps?: Partial<IconButtonProps>
}

export const ActionsCell = (props: Props) => {
  const { onDelete, id, disabled, tooltip, buttonProps = {} } = props

  const handleClickDelete = useCallback(
    (_e: React.MouseEvent) => {
      onDelete(id)
    },
    [onDelete, id]
  )

  return (
    <Tooltip arrow title={tooltip}>
      <Box>
        <IconButton
          disableRipple
          disableFocusRipple
          disableTouchRipple
          size="medium"
          onClick={handleClickDelete}
          borderRadius="circle"
          disabled={disabled}
          {...buttonProps}
        >
          <Delete />
        </IconButton>
      </Box>
    </Tooltip>
  )
}
